// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"2dc0e0c1","916":"07be5bdd"}[chunkId] + ".chunk.js";
};